import React from "react";
import blog from "../../../assets/img/blog.svg";
import blog_card from "../../../assets/img/blog_card.svg";
import { useEffect } from "react";
import { getBlogListData } from "../../../Redux/Common/BlogSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import Loader from "../../Loader/Loader"; // adjust the path
import { useGlobalState } from "../../../Providers/GlobalStateProvider";

const Blog = () => {
  const featuredBlog = {
    id: 1,
    title: "Featured Blog Post Title",
    content:
      "Featured Blog Post Description here, Featured Blog Post Description hereFeatured Blog Post Description here, Featured Blog Post Description here.",
    image: blog,
    category: "Featured",
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { setGlobalLoading } = useGlobalState();

  const [featuredBlogData, setFeaturedBlogData] = useState(null);
  const [blogData, setBlogData] = useState(null);
  const [loading, setLoading] = useState(true);

  const getBlogListResponse = useSelector((state) => state.getBlogReducer.data);

  useEffect(() => {
    dispatch(getBlogListData());
    setGlobalLoading(true);
  }, []);

  useEffect(() => {
    if (getBlogListResponse != null && getBlogListResponse.status === true) {
      setFeaturedBlogData(getBlogListResponse.data[0]);
      setBlogData(getBlogListResponse.data.slice(1));
      setLoading(false);
      setGlobalLoading(false);
    } else if (getBlogListResponse != null) {
      setLoading(false);
      setGlobalLoading(false);
      console.error("Error fetching home data:", getBlogListResponse.message);
    }
  }, [getBlogListResponse]);

  const handleViewDetails = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (loading) {
    setGlobalLoading(true);
    return <div style={{ height: "100vh" }}><Loader /></div>;
  }
  return (
    <div className="blog-listing">
      {/* Featured Blog Section */}
      <div >
        <div className="custom_container">
          <div className="featured-blog">
            <Row className="flex-column-reverse flex-md-row">
              <Col lg={7}>
                <div className="featured-blog__content">
                  <h1 className="featured-blog__title">{featuredBlogData.title}</h1>
                  <p className="blog-card__description" dangerouslySetInnerHTML={{ __html: featuredBlogData.content }}>
                  </p>
                  <button className="btn btn-primary" onClick={() => {
                    handleViewDetails();
                    navigate(`/blog-detail/${featuredBlogData._id}`);
                  }}>Read More</button>
                </div>
              </Col>
              <Col lg={5}>
                <div className="featured-blog__image">
                  <img src={featuredBlogData.image} alt={featuredBlogData.title} />
                </div>{" "}
              </Col>
            </Row>
          </div>
        </div>

        {/* Blog Grid Section */}
        <div className="py-4 py-sm-5" style={{ backgroundColor: "#fff" }}>
          <div className="custom_container">
            <div
              className="blog-grid"
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
                gap: "20px",
              }}
            >
              {blogData &&
                blogData.map((item) => (
                  <div
                    key={item._id}
                    className="blog-card"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                      border: "1px solid #eee",
                    }}
                  >
                    <div className="blog-card__image">
                      <img
                        src={item.image}
                        alt={item.title}
                        style={{ width: "100%", height: "200px", objectFit: "cover" }}
                      />
                    </div>

                    <div
                      className="blog-card__content"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        flexGrow: 1,
                        padding: "16px",
                      }}
                    >
                      <span className="blog-card__category">{item.tags}</span>

                      <h3 className="blog-card__title">{item.title}</h3>

                      <p
                        className="blog-card__description"
                        style={{ flexGrow: 1 }}
                        dangerouslySetInnerHTML={{ __html: item.content }}
                      />

                      <button
                        className="btn btn-secondary"
                        style={{
                          marginTop: "auto",
                          width: "100%",
                        }}
                        onClick={() => {
                          handleViewDetails();
                          navigate(`/blog-detail/${item._id}`);
                        }}
                      >
                        Read More
                      </button>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>

    </div>
    </div>
  );
};

export default Blog;
